import React, { useContext, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import StandardDropdown from '@wix/da-ds/pkg/Dropdown/Preset/StandardDropdown';
import s from './ThreadOrderSelect.scss';
const ThreadOrderSelect = ({ streamId, order, onOrderChangedDefault, onOrderChanged = onOrderChangedDefault })=>{
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const handleOrderChanged = useCallback((value)=>{
        onOrderChanged && onOrderChanged(streamId, value);
    }, [
        onOrderChanged,
        streamId
    ]);
    const items = useMemo(()=>[
            {
                label: t('commentthread.control.newest'),
                value: 'newest'
            },
            {
                label: t('commentthread.control.oldest'),
                value: 'oldest'
            }
        ], [
        t
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: s['order-select']
    }, /*#__PURE__*/ React.createElement(StandardDropdown, {
        role: "menu",
        placement: isMobile ? 'bottom-end' : 'bottom-start',
        toggleClassName: s['order-select-toggle'],
        arrowClassName: s['order-select-arrow'],
        selectedValue: order,
        items: items,
        onSelect: handleOrderChanged
    }));
};
ThreadOrderSelect.displayName = 'ThreadOrderSelect';
export default ThreadOrderSelect;

//# sourceMappingURL=ThreadOrderSelect.js.map